import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/app/(public)/course-info/components/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1497620650/src/basic-traning-frontend/node_modules/next/dist/client/app-dir/link.js");
